(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/frejaeid/assets/javascripts/frejaeid.js') >= 0) return;  svs.modules.push('/components/app/frejaeid/assets/javascripts/frejaeid.js');
(function(svs) {
  var ACTION_TYPE = {
    SUSPENSION: 0,
    SUBSCRIPTION: 1
  };

  const { Confirm, message, api } = svs.ui.dialog;

  function frejaeidErrorHandler(actionType, xhr, failEvent) {
    var errorCode; var errorMessage;
    if (svs.utils.ns.isNamespace('responseJSON.error.code', xhr || {})) {
      errorCode = xhr.responseJSON.error.code;
    }
    switch (errorCode) {
      case 1:
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage = 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        } else {
          errorMessage = 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        }
        break;
      case 51: 
        svs.app.frejaeid.logger.debug('User cancelled');
        var message = '';
        var type;
        if (actionType === ACTION_TYPE.SUSPENSION) {
          message = 'Bekräftelse av spelpaus avbröts';
          type = svs.ui.dialog.area.POPUP;
        } else {
          message = 'Skapandet av autogiromedgivande avbröts';
          type = svs.ui.dialog.area.TOASTER;
        }
        var errorDialog = new svs.ui.dialog.Confirm({
          area: type,
          type: svs.ui.dialog.type.ERROR,
          autoClose: svs.ui.dialog.autoClose.MEDIUM,
          title: message,
          actions: [
            {
              title: 'Okej'
            }
          ]
        });
        svs.ui.dialog.api.add(errorDialog); 
        if (failEvent) {
          svs.components.analytics.trackEvent(failEvent);
        }
        break;
      default:
        svs.app.frejaeid.logger.error('Unhandle freja eid error', xhr);
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage = 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        } else {
          errorMessage = 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        }
    }
    if (errorMessage) {
      var loggerInfo = '';
      var title = '';
      if (actionType === ACTION_TYPE.SUSPENSION) {
        loggerInfo = 'Suspension request with frejaeid failure';
        title = 'Misslyckad verifiering';
      } else {
        loggerInfo = 'Direct debit permission request with frejaeid failure';
        title = 'Misslyckat autogiromedgivande';
      }
      svs.app.frejaeid.logger.info(loggerInfo);
      var _dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: title,
        message: [
          {
            type: svs.ui.dialog.message.TEXT,
            text: errorMessage
          }
        ],
        actions: [
          {
            title: 'Okej'
          }
        ]
      });
      svs.ui.dialog.api.add(_dialog); 
    }
  }

  function showFrejaEidProgress(options, successFn, errorFn, context, successEvent, response) {
    var checker = new svs.app.frejaeid.Checker({
      authRef: response.authRef
    });
    var isMobile = svs.core.detect.formfactor.mobile();
    checker.model.once('change:postToken', function(model, value) {
      confirmDialog.close();
      successFn && successFn.call(context, { postToken: value });
      if (successEvent) {
        svs.components.analytics.trackEvent(successEvent);
      }
    });
    checker.model.once('change:error', function(model, value) {
      confirmDialog.close();
      errorFn.call(context, value);
    });
    const confirmDialog = new Confirm({
      branding: svs.ui.dialog.branding[svs.utils.branding.siteWide()],
      icon: options.icon || 'mobile', 
      title: options?.title ? options.title : 'Freja eID',
      message: [
        {
          type: message.TEXT,
          text: isMobile ? 'Försöker starta Freja eID-appen' : 'Skanna QR-koden med Freja eID-appen',
          align: message.align.CENTER
        },
        {
          type: svs.ui.dialog.message.TEXT,
          text: isMobile ? '<div class="js-loader-container relative"></div>' : `<div class="qrCode"><p style="width:100px; height:100px;"></p></div>`,
          align: svs.ui.dialog.message.align.CENTER
        }
      ],
      actions: isMobile ? [
        {
          title: 'Avbryt',
          callback: () => {
            checker.stopPolling();
            errorFn.call(context, {
              responseJSON: {
                error: {
                  code: 51
                }
              }
            });
            confirmDialog.close();
          }
        },
        {
          title: 'Öppna Freja eID-appen',
          callback: () => {
            checker.startPolling();
            window.location.href = svs.app.frejaeid.getFrejaEidStartParams(response.authRef);
          }
        }
      ] :
      [
        {
          title: 'Avbryt',
          callback: () => {
            checker.stopPolling();
            errorFn.call(context, {
              responseJSON: {
                error: {
                  code: 51
                }
              }
            });
            confirmDialog.close();
          }
        }
      ]
    });

    const loader = new svs.ui.Loader('.js-loader-container');
    loader.show(200, 'inverted');
    checker.startPolling();
    api.add(confirmDialog);

    if (isMobile) {
      window.location.href = svs.app.frejaeid.getFrejaEidStartParams(response.authRef);
    } else {
      svs.app.frejaeid.qrCodeGenerate(response.authRef);
    }
  }
  function authenticate(options, successFn, errorFn, context, successEvent, failEvent) {
    var errFn =
      errorFn ||
      function(xhr) {
        frejaeidErrorHandler(ACTION_TYPE.SUSPENSION, xhr, failEvent);
      };
    options = options || {};
    options.title = options.title || 'Bekräfta spelpaus';
    options.icon = 'spelpaus';
    this.initAuth(showFrejaEidProgress.bind(this, options, successFn, errFn, context, successEvent), errFn);
  }
  function initAuth(successFn, errorFn, successEvent) {
    var errFn =
        errorFn ||
        function(xhr) {
          frejaeidErrorHandler(ACTION_TYPE.SUSPENSION, xhr);
        };
    var succFunc =
        successFn ||
        function() {
          svs.app.frejaeid.logger.info('Successfully initAuth for Freja eID');
        };
    if (successEvent) {
      svs.components.analytics.trackEvent(successEvent);
    }
    svs.core.jupiter.call(
      {
        path: '/player/1/frejaeid/initauthsign',
        method: 'POST',
        data: {},
        context: this
      },
      succFunc,
      errFn
    );
  }
  function getFrejaEidStartParams(authRef) {
    var url;
    var logger = svs.core.log.getLogger('app:frejaeid');
    if (svs.core.detect.os.android()) {
      url = 'frejaeid://bindUserToTransaction?transactionReference=' + authRef;
    } else if (svs.core.detect.formfactor.desktop() && !svs.core.detect.os.iOS()) {
      url = 'frejaeid://bindUserToTransaction?transactionReference=' + authRef;
    } else {
      url = 'frejaeid://bindUserToTransaction?transactionReference=' + authRef + '&originAppScheme=' + getReturnUrl(authRef);
    }
    logger.debug('Freja eID start url: ' + url);
    return url;
  }
  function getReturnUrl() {
    var returnUrl;
    var logger = svs.core.log.getLogger('app:frejaeid');
    var userAgent = navigator?.userAgent?.toLowerCase() || '';
    var isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;

    if (svs.core.detect.os.iOS()) {
      if (isNativeApp) {
        returnUrl = encodeURIComponent(window.location.href.replace(/https?/i, svs.core.detect.tenant('tb') ? 'spelbutiken.bankid' : 'spelbutikenlb.bankid'));
      } else if (svs.core.detect.browser.crios()) {
        if (window.location.protocol.indexOf('s') > -1) {
          returnUrl = 'googlechromes://';
        } else {
          returnUrl = 'googlechrome://';
        }
      } else if (userAgent.indexOf('firefox') > -1 || userAgent.indexOf('fxios') > -1) {
        returnUrl = 'firefox://';
      } else if (userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg') > -1 || userAgent.indexOf('edgios') > -1) {
        if (window.location.protocol.indexOf('s') > -1) {
          returnUrl = 'microsoft-edge-https://';
        } else {
          returnUrl = 'microsoft-edge-http://';
        }
      } else if (userAgent.indexOf('safari') > -1) {
        returnUrl = encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
      } else {
        returnUrl = 'null'; 
      }
    } else {
      returnUrl = 'null';
    }
    logger.debug('Freja eID return url: ' + returnUrl);
    return returnUrl;
  }
  function qrCodeGenerate(authRef) {
    var qrCodeId = authRef;
    if (qrCodeId !== undefined && qrCodeId.length > 0) {
      qrCodeId = getFrejaEidStartParams(authRef);
      $(function() {
        $('.qrCode')
          .empty()
          .qrcode({
            size: 120,
            color: '#3a3',
            text: qrCodeId
          });
      });
    }
  }
  svs.app.frejaeid.suspensionDefaultErrorHandler = frejaeidErrorHandler.bind(this, ACTION_TYPE.SUSPENSION);
  svs.app.frejaeid.verifySuspensionRequest = authenticate;
  svs.app.frejaeid.initAuth = initAuth;
  svs.app.frejaeid.qrCodeGenerate = qrCodeGenerate;
  svs.app.frejaeid.getFrejaEidStartParams = getFrejaEidStartParams;
})(svs);


 })(window);